import * as actionTypes from "../constants";

// ** Define types for the state and actions
interface Substance {
  id: string;
  label: string;
  value: string;
}

interface Condition {
  id: string;
  label: string;
  value: string;
}

interface Allergy {
  id: string;
  label: string;
  value: string;
  allergy: string;
  severity: string;
}

interface Group {
  id: string;
  label: string;
  value: string;
}

interface ContraindicationsState {
  end: boolean;
  loading: boolean;
  allSubstances: Substance[];
  allConditions: Condition[];
  allAllergies: Allergy[];
  allContraindications: any[];
  allGroups: Group[];
  screeningTestResult: any[];
}

interface Action {
  type: string;
  payload?: any;
}

const initialState: ContraindicationsState = {
  end: true,
  loading: false,
  allSubstances: [],
  allConditions: [],
  allAllergies: [],
  allContraindications: [],
  allGroups: [],
  screeningTestResult:
    JSON.parse(localStorage.getItem("screeningResult") || "[]") || [],
};

const reducer = (
  prevState = initialState,
  action: Action
): ContraindicationsState => {
  switch (action.type) {
    case actionTypes.GET_ALL_SUBSTANCES_SUCCESS: {
      const substances: Substance[] = action.payload
        ?.map((_item: any) => {
          if (_item.role !== "user") {
            return {
              id: _item.id,
              label: _item.substanceName,
              value: _item.substanceName,
            };
          }
          return null;
        })
        .filter(Boolean); // Filter out null values
      return {
        ...prevState,
        allSubstances: substances,
      };
    }

    case actionTypes.GET_ALL_CONDITIONS_SUCCESS: {
      const conditions: Condition[] = action.payload
        ?.map((_item: any) => {
          if (_item.role !== "user") {
            return {
              id: _item.id,
              label: _item.condition,
              value: _item.condition,
            };
          }
          return null;
        })
        .filter(Boolean); // Filter out null values
      return {
        ...prevState,
        allConditions: conditions,
      };
    }
    case actionTypes.SET_SCREENING_RESULT: {
      localStorage.setItem("screeningResult", JSON.stringify(action.payload));
      return {
        ...prevState,
        screeningTestResult: action.payload,
      };
    }

    case actionTypes.GET_ALL_ALLERGIES_SUCCESS: {
      const allergies: Allergy[] = action.payload
        ?.map((_item: any) => {
          if (_item.role !== "user") {
            return {
              id: _item.id,
              label: _item.allergy,
              value: _item.allergy,
              allergy: _item.allergy,
              severity: _item.severity,
            };
          }
          return null;
        })
        .filter(Boolean); // Filter out null values
      return {
        ...prevState,
        allAllergies: allergies,
      };
    }

    case actionTypes.GET_ALL_CONTRAINIDATIONS_SUCCESS:
      return {
        ...prevState,
        allContraindications: action.payload,
      };

    case actionTypes.GET_ALL_GROUPS_SUCCESS: {
      const groups: Group[] = action.payload
        ?.map((_item: any) => {
          if (_item.role !== "user") {
            return {
              id: _item.id,
              label: _item.groupName,
              value: _item.groupName,
            };
          }
          return null;
        })
        .filter(Boolean); // Filter out null values
      return {
        ...prevState,
        allGroups: groups,
      };
    }

    case actionTypes.DELETE_ALL_CONTRAINIDATIONS:
      return {
        ...prevState,
        allSubstances: [],
        allConditions: [],
        allContraindications: [],
        allGroups: [],
      };

    default:
      return prevState;
  }
};

export default reducer;
